import { workspacePath, type FactsheetWorkspace } from "@/datox/workspaces"

// The redesign covers reporting and workspace routes. Native session routes keep
// their existing shell; /chats keeps the existing library component.
const libraries = new Set([
  "/reports", "/chats", "/factsheets", "/overview", "/files", "/projects",
  "/automations", "/integrations", "/templates", "/agents", "/approvals",
  "/catalog/reports", "/catalog/dashboards", "/catalog/workflows",
])

export function v2ShellPath(pathname: string) {
  const path = pathname.replace(/\/$/, "")
  return libraries.has(path) || /^\/reports\/[^/]+\/[^/]+$/.test(path) || /^\/catalog\/workflows\//.test(path)
}

export function reportHref(workspace: FactsheetWorkspace, targetID?: string) {
  const path = workspacePath(workspace)
  if (!targetID || workspace.legacy_dashboard_id || workspace.legacy_artifact_id) return path
  return `${path}?${new URLSearchParams({ target: targetID })}`
}

export function reportCreationRequested(search: Record<string, unknown>) {
  return search.create === "1" || !!search.definition_id || !!search.source_workspace_id || !!search.source_dashboard_id
}
